import { galaxy, infinity, nova, quantum, titan, ultimate } from '../ui/images';

export const periods = ['Day', 'Week', 'Month', 'Year'];
export const daysInPeriod = [1, 7, 30, 365];

export const packagesData = [
  {
    name: 'Nova',
    image: nova,
    price: 100,
    daily: { crat: 0.41, cit: 95.89 },
    units: { available: 0, total: 100 },
    profitUSD: [1.11, 7.8, 33.26, 404.74],
    contractId: 0,
  },
  {
    name: 'Titan',
    image: titan,
    price: 200,
    daily: { crat: 0.88, cit: 200 },
    units: { available: 0, total: 100 },
    profitUSD: [2.33, 16.31, 69.98, 851.47],
    contractId: 1,
  },
  {
    name: 'Quantum',
    image: quantum,
    price: 500,
    daily: { crat: 2.33, cit: 547.95 },
    units: { available: 0, total: 100 },
    profitUSD: [6.33, 44.31, 189.77, 2299.9],
    contractId: 2,
  },
  {
    name: 'Infinity',
    image: infinity,
    price: 1000,
    daily: { crat: 5.07, cit: 1095.89 },
    units: { available: 0, total: 200 },
    profitUSD: [12.98, 90.86, 389.5, 4739.54],
    contractId: 3,
  },
  {
    name: 'Galaxy',
    image: galaxy,
    price: 2750,
    daily: { crat: 15.07, cit: 3013.7 },
    units: { available: 0, total: 200 },
    profitUSD: [36.62, 256.34, 1098.53, 13365.45],
    contractId: 4,
  },
  {
    name: 'Ultimate',
    image: ultimate,
    price: 5000,
    daily: { crat: 27.95, cit: 5753.43 },
    units: { available: 0, total: 300 },
    profitUSD: [69.24, 484.68, 2077.27, 25273.45],
    contractId: 5,
  },
];
